import { defineComponent as _defineComponent } from 'vue'
import Vue, { reactive, ref, watch } from 'vue'
import { Skeleton, Spin, Pagination, Empty } from 'ant-design-vue'
import useList from '@/hooks/useList'
import { getNoticeList } from '@/api/notice'
import routerByNoticeTag, { getNoticeTagName } from '@/utils/noticeTag'
import { toDetail } from '@/utils'
import dayjs from 'dayjs'
import useInit from '@/hooks/useInit'
import { getHTMLText } from '@/utils/index'

type Props = {
  /** 显示顶部的分页器 */
  showTopPagination?: boolean
  /** 列表所查询的`noticeTag` */
  noticeTags: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    showTopPagination: { type: Boolean, default: true },
    noticeTags: null
  },
  setup(__props: any) {

const props = __props as { showTopPagination: boolean, noticeTags: string };



const { dataList, loading, pagination, onQueryList } = useList<NoticeItem>({
  getList: getNoticeList,
  formatGetListQuery(query) {
    return {
      ...query,
      noticeTags: props.noticeTags,
      /** 排序方式 1 创建时间 2 发布时间倒序 3 浏览量 4 发布时间正序 */
      sortBy: 2,
    }
  },
})

const { loading: skeletonLoading } = useInit(dataList)

watch(
  () => [pagination.current, pagination.pageSize],
  () => {
    onQueryList()
  }
)

function onClickTag(item: NoticeItem) {
  routerByNoticeTag(item.noticeTag)
}

function onClick(item: NoticeItem) {
  toDetail(item)
}

const hideImg = reactive<Record<string, boolean>>({})
function handleImgError(item: NoticeItem) {
  Vue.set(hideImg, item.id, true)
}

return { __sfc: true,props, dataList, loading, pagination, onQueryList, skeletonLoading, onClickTag, onClick, hideImg, handleImgError, Skeleton, Spin, Pagination, Empty, getNoticeTagName, dayjs, getHTMLText }
}

})